module.exports = __webpack_public_path__ + "static/media/save_active.b7212e91.svg";